import {
  PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_BEGIN,
  PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_SUCCESS,
  PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_FAILURE,
  PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadAllInstalledPlugin(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/plugins/`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadAllInstalledPluginError() {
  return {
    type: PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_BEGIN:
      return {
        ...state,
        loadAllInstalledPluginPending: true,
        loadAllInstalledPluginError: null,
      };

    case PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_SUCCESS:
      return {
        ...state,
        loadAllInstalledPluginPending: false,
        loadAllInstalledPluginError: null,
        installedPlugins: action.data ? action.data : [],
      };

    case PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_FAILURE:
      return {
        ...state,
        loadAllInstalledPluginPending: false,
        loadAllInstalledPluginError: action.data.error,
      };

    case PLUGIN_LOAD_ALL_INSTALLED_PLUGIN_DISMISS_ERROR:
      return {
        ...state,
        loadAllInstalledPluginError: null,
      };

    default:
      return state;
  }
}
